import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/app/portfolio/components/PortfolioInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/components/common/WhatsAppButton.tsx");
